import axios from 'axios';
import config from '../config'
import {ACTION_TYPES} from "../reducers/badge";
const API_ROOT = config.API_ROOT
export const load = () => (dispatch, getState) => {
  const userId = getState().user.jwt_user_id;
  //console.log(123, getState().user.id)
  return dispatch({
    type: ACTION_TYPES.LOAD,
    payload: axios.get(`${API_ROOT}/badge/${userId}/`,{
      headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }
    }),
  });
};
export const reset = () => ({type: ACTION_TYPES.RESET});

export const markAsSeen = badgeIds => (dispatch, getState) => {
  const userId = getState().user.id;
  const data = {
    badgeIds: badgeIds,
  };
  return dispatch({
    type: ACTION_TYPES.MARK_AS_SEEN,
    meta: {
      badgeIds: badgeIds,
    },
    payload: axios.post(`${API_ROOT}/badge/${userId}/mark`, data, {
      headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwt') }
    }),
  });
};
